module.exports = __webpack_public_path__ + "static/0082-e2a2ab61757be950d2fdbc48c1a7d5c3.png";